import { apiService } from './api';

/**
 * Sets or removes a person's profile photo, from wherever we meet them. All
 * three write the same Person photo (the server deletes the one it replaces):
 *   - staff on an application
 *   - the family on their status link
 *   - staff on an enrolled student
 */
export type PhotoOwner =
  | { application: string }
  | { statusToken: string }
  | { student: string };

const endpoint = (owner: PhotoOwner): string =>
  'application' in owner ? `/admission-applications/${owner.application}/photo`
    : 'statusToken' in owner ? `/public/status/${owner.statusToken}/photo`
      : `/students/${owner.student}/photo`;

export const personPhotoService = {
  /** Upload a photo, replacing any previous one. Resolves with the stored filename. */
  upload: async (owner: PhotoOwner, file: File): Promise<string> => {
    const form = new FormData();
    form.append('photo', file);
    const r = await apiService.upload<{ photoFilename: string }>(endpoint(owner), form);
    return r.data!.photoFilename;
  },

  remove: async (owner: PhotoOwner): Promise<void> => {
    await apiService.delete(endpoint(owner));
  },
};
